import { get } from '../libs/Axios';
import BaseFormComponent from '../abstracts/BaseFormComponent';

export default class OrderGuestComponent extends BaseFormComponent {
  get Messages() {
    return {};
  }

  get SELECTORS() {
    return {};
  }

  constructor(element) {
    super(element);
    this.handleSubmit();
  }

  handleSubmit() {
    this.onSubmit(async (e, action, button) => {
      this.loading(button);
      try {
        const formData = this.serializeForm(e.currentTarget).getData();
        window.location.assign(`${action}?${formData}`);
      } catch (err) {
        console.error(err);
      }
    });
  }
}
